module.exports = __webpack_public_path__ + "static/media/purple-exp-bar.77147074.png";